export const PermissionGroupPermissionXRefAllTR={
PeGPID:{en:'PeGPID',cs:'PeGPID',dataType:'number',format:'#0',required:true},
PeGPPerGID:{en:'PeGPPerGID',cs:'PeGPPerGID',dataType:'number',format:'#0',required:true},
PeGPPermID:{en:'PeGPPermID',cs:'PeGPPermID',dataType:'number',format:'#0',required:true},
PerGIsActive:{en:'Active',cs:'',dataType:'boolean'},
PermNameCaption:{en:'PermNameCaption',cs:'PermNameCaption',dataType:'string',maxLength:255}
}